/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTable, useBlockLayout, usePagination } from 'react-table';
import { useSticky } from 'react-table-sticky';
import './styles.scss';

import ScrollContainer from 'react-indiana-drag-scroll';

const EpTable = ({ tableData, columns, hiddenColumns }) => {
  const data = tableData ? tableData.itens : [];

  const controlledPageCount = tableData ? tableData.totalPages : null;

  const defaultColumn = useMemo(
    () => ({
      minWidth: 150,
      // width: auto,
      maxWidth: 440,
    }),
    [],
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setHiddenColumns,
  } = useTable({
    columns,
    data,
    defaultColumn,
    manualPagination: true,
    pageCount: controlledPageCount,
    initialState: { hiddenColumns },
  }, useBlockLayout, usePagination,
  useSticky);

  // Atualiza a visualização das colunas na tabela
  useEffect(
    () => {
      const arr = [...hiddenColumns];
      setHiddenColumns(arr);
    },
    [hiddenColumns],
  );

  return (
    <ScrollContainer className="scroll-container" hideScrollbars="false" ignoreElements="span">
      <table
        className="table table--sticky"
        {...getTableProps()}
      >
        <thead className="table-light table__head">
          {headerGroups.map(headerGroup => (
            <tr className="table__head-row" {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  scope="col"
                  {...column.getHeaderProps()}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="table__body" {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr className="table__body-row" {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td
                    {...cell.getCellProps()}
                  >
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </ScrollContainer>
  );
};

export default EpTable;

EpTable.defaultProps = {
  tableData: null,
  hiddenColumns: [],
};

EpTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tableData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.object),
  ])),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  hiddenColumns: PropTypes.arrayOf(PropTypes.string),
};
